// Standard WBS discipline lookup, generated from
// "Work Breakdown Structure Data Dictionary - for Fusion.xlsx" (Consolidated sheet).
// Cost codes are 6 digits: first digit = Area (1-4), last 5 identify the phase.
// Keys below are the 5-digit tails; d = discipline (service-offering suffix stripped,
// collisions resolved by majority then Pipeline > Facility > E&I > Engineering > CP > Shop Fab),
// o = standard sort order (used to order discipline sections).
export const WBS_STANDARD = {
    '00101': { d: "Project Support", o: 5 },
    '00102': { d: "Project Support", o: 9999 },
    '00103': { d: "Project Support", o: 4 },
    '00104': { d: "Project Support", o: 8 },
    '00105': { d: "Project Support", o: 4 },
    '00108': { d: "Project Support", o: 9999 },
    '00109': { d: "Project Support", o: 3 },
    '00201': { d: "Project Support", o: 4 },
    '00302': { d: "Project Support", o: 9999 },
    '00303': { d: "Project Support", o: 6 },
    '00401': { d: "Mob / Demob", o: 14 },
    '00402': { d: "Mob / Demob", o: 15 },
    '00403': { d: "Mob / Demob", o: 13 },
    '00503': { d: "Project Support", o: 7 },
    '00504': { d: "Test & Commissioning-Shop Fab", o: 9999 },
    '00505': { d: "Project Support", o: 9999 },
    '00601': { d: "Project Support", o: 9999 },
    '00604': { d: "Sitework", o: 19 },
    '00901': { d: "Project Support", o: 9 },
    '01001': { d: "Project Support", o: 8 },
    '10110': { d: "Civil", o: 20 },
    '10111': { d: "Civil", o: 21 },
    '10112': { d: "Civil", o: 22 },
    '10201': { d: "Engineering", o: 9999 },
    '10202': { d: "Engineering", o: 9999 },
    '10301': { d: "Engineering", o: 9999 },
    '10302': { d: "Engineering", o: 9999 },
    '10311': { d: "Mechanical", o: 8 },
    '10501': { d: "Engineering", o: 9999 },
    '10503': { d: "Engineering", o: 9999 },
    '10603': { d: "Piping Fabrication", o: 9999 },
    '10606': { d: "Project Support", o: 9999 },
    '10608': { d: "Shipping", o: 9999 },
    '10609': { d: "Valves & Equipment", o: 9999 },
    '10611': { d: "Structural Fab", o: 9999 },
    '10612': { d: "Piping Fabrication", o: 9999 },
    '10613': { d: "Paint", o: 9999 },
    '10614': { d: "Test & Commissioning-Shop Fab", o: 9999 },
    '10615': { d: "Structural Fab", o: 9999 },
    '10616': { d: "Shipping", o: 9999 },
    '10617': { d: "Inspection", o: 9999 },
    '10618': { d: "Structural Fab", o: 9999 },
    '10701': { d: "Process", o: 6 },
    '10801': { d: "Piping", o: 10 },
    '10901': { d: "Electrical", o: 12 },
    '10902': { d: "Electrical", o: 13 },
    '10903': { d: "Electrical", o: 14 },
    '11001': { d: "Instrumentation", o: 16 },
    '11002': { d: "Instrumentation", o: 17 },
    '11003': { d: "Instrumentation", o: 18 },
    '11101': { d: "Structural", o: 24 },
    '11102': { d: "Structural", o: 25 },
    '11103': { d: "Structural", o: 26 },
    '11201': { d: "Pipeline", o: 28 },
    '11202': { d: "Pipeline", o: 29 },
    '11203': { d: "Pipeline", o: 30 },
    '11204': { d: "Pipeline", o: 30 },
    '11205': { d: "Pipeline", o: 31 },
    '20101': { d: "E & I", o: 73 },
    '20102': { d: "Cable Tray", o: 17 },
    '20103': { d: "I&E", o: 9999 },
    '20107': { d: "I&E", o: 9999 },
    '20108': { d: "Terminations", o: 29 },
    '20110': { d: "I&E", o: 9999 },
    '20111': { d: "Electrical Equipment", o: 37 },
    '20114': { d: "Conduit", o: 20 },
    '20115': { d: "Conduit", o: 21 },
    '20116': { d: "Wire & Cable", o: 24 },
    '20117': { d: "Wire & Cable", o: 25 },
    '20118': { d: "Wire & Cable", o: 27 },
    '20119': { d: "Terminations", o: 30 },
    '20120': { d: "Terminations", o: 31 },
    '20121': { d: "Wire & Cable", o: 26 },
    '20122': { d: "Electrical Equipment", o: 38 },
    '20123': { d: "Conduit", o: 19 },
    '20124': { d: "Wire & Cable", o: 23 },
    '20201': { d: "Electrical Equipment", o: 34 },
    '20202': { d: "Electrical Equipment", o: 35 },
    '20203': { d: "Electrical Equipment", o: 33 },
    '20301': { d: "Instrumentation", o: 40 },
    '20302': { d: "Instrumentation", o: 41 },
    '20303': { d: "Instrumentation", o: 42 },
    '20304': { d: "Instrumentation", o: 43 },
    '20305': { d: "Instrumentation", o: 44 },
    '20401': { d: "Engineering", o: 9999 },
    '30301': { d: "Site Prep", o: 20 },
    '30401': { d: "Sitework", o: 14 },
    '30403': { d: "Sitework", o: 17 },
    '30601': { d: "Site Prep", o: 27 },
    '30604': { d: "Sitework", o: 23 },
    '30605': { d: "Sitework", o: 24 },
    '30607': { d: "Civil/Concrete", o: 47 },
    '30608': { d: "Civil/Concrete", o: 48 },
    '30610': { d: "Sitework", o: 18 },
    '30611': { d: "Sitework", o: 20 },
    '30612': { d: "Sitework", o: 22 },
    '30705': { d: "Sitework", o: 21 },
    '40101': { d: "Site Prep", o: 22 },
    '40102': { d: "Site Prep", o: 23 },
    '40103': { d: "Site Prep", o: 21 },
    '40104': { d: "Site Prep", o: 24 },
    '40105': { d: "Site Prep", o: 25 },
    '40108': { d: "Site Prep", o: 17 },
    '40201': { d: "Dirtwork", o: 50 },
    '40206': { d: "Dirtwork", o: 49 },
    '40401': { d: "Sitework", o: 15 },
    '40403': { d: "Site Prep", o: 18 },
    '40404': { d: "Site Prep", o: 19 },
    '40601': { d: "Pipe", o: 31 },
    '40602': { d: "Pipe", o: 30 },
    '40604': { d: "Pipe", o: 32 },
    '40605': { d: "Pipe", o: 33 },
    '40606': { d: "Pipe", o: 34 },
    '40701': { d: "Pipe", o: 35 },
    '40801': { d: "Pipe", o: 36 },
    '41001': { d: "Pipe", o: 37 },
    '41101': { d: "Pipe", o: 38 },
    '41201': { d: "Paint / Coating", o: 47 },
    '41203': { d: "Paint / Coating", o: 45 },
    '41301': { d: "Pipe", o: 40 },
    '41303': { d: "Dirtwork", o: 51 },
    '41501': { d: "Tie-ins", o: 54 },
    '41504': { d: "Tie-ins", o: 55 },
    '41505': { d: "Tie-ins", o: 56 },
    '41506': { d: "Tie-ins", o: 57 },
    '41507': { d: "Tie-ins", o: 53 },
    '41601': { d: "Pipe", o: 41 },
    '41701': { d: "Testing", o: 64 },
    '41705': { d: "Shipping", o: 9999 },
    '41707': { d: "Testing", o: 65 },
    '41708': { d: "Testing", o: 66 },
    '41709': { d: "Testing", o: 67 },
    '41710': { d: "Testing", o: 63 },
    '41803': { d: "HDD / Bore", o: 61 },
    '41903': { d: "HDD / Bore", o: 60 },
    '41911': { d: "HDD / Bore", o: 59 },
    '42001': { d: "Site Prep", o: 26 },
    '42101': { d: "Pipe", o: 42 },
    '42107': { d: "Building", o: 75 },
    '42108': { d: "Steel", o: 71 },
    '42109': { d: "Paint / Coating", o: 46 },
    '42110': { d: "Pipe", o: 43 },
    '42201': { d: "Pipe", o: 39 },
    '42301': { d: "Project Support", o: 11 },
    '42701': { d: "Composite", o: 79 },
    '42711': { d: "Pipe", o: 29 },
    '42801': { d: "Cathodic Protection", o: 8 },
    '50101': { d: "Civil/Concrete", o: 26 },
    '50121': { d: "Civil/Concrete", o: 27 },
    '50122': { d: "Civil/Concrete", o: 28 },
    '50123': { d: "Civil/Concrete", o: 29 },
    '50124': { d: "Civil/Concrete", o: 30 },
    '50125': { d: "Civil/Concrete", o: 31 },
    '50126': { d: "Civil/Concrete", o: 33 },
    '50201': { d: "Civil/Concrete", o: 34 },
    '50301': { d: "Equipment", o: 48 },
    '50401': { d: "Civil/Concrete", o: 32 },
    '60201': { d: "Pipe", o: 51 },
    '60205': { d: "Paint / Coat", o: 65 },
    '60206': { d: "Mechanical Assembly-Shop Fab", o: 9999 },
    '60207': { d: "Pipe", o: 57 },
    '60208': { d: "Shipping", o: 9999 },
    '60209': { d: "Structural Fab", o: 9999 },
    '60302': { d: "Equipment", o: 44 },
    '60304': { d: "Equipment", o: 45 },
    '60306': { d: "Equipment", o: 47 },
    '60315': { d: "Piping Fabrication", o: 9999 },
    '60318': { d: "Testing", o: 74 },
    '60320': { d: "Shipping", o: 9999 },
    '60321': { d: "Pipe", o: 56 },
    '60322': { d: "Pipe", o: 52 },
    '60323': { d: "Pipe", o: 53 },
    '60325': { d: "Equipment", o: 46 },
    '60326': { d: "Pipe", o: 54 },
    '60327': { d: "Pipe", o: 55 },
    '60328': { d: "Paint / Coat", o: 67 },
    '60330': { d: "Pipe", o: 50 },
    '60331': { d: "Testing", o: 75 },
    '60332': { d: "Paint / Coat", o: 66 },
    '60333': { d: "Paint / Coat", o: 68 },
    '60402': { d: "Pre-commissioning", o: 77 },
    '60501': { d: "Structural Fab", o: 9999 },
    '60506': { d: "Structural Steel", o: 37 },
    '60507': { d: "Structural Steel", o: 39 },
    '60508': { d: "Structural Steel", o: 40 },
    '60509': { d: "Structural Steel", o: 42 },
    '60510': { d: "Structural Steel", o: 38 },
    '60511': { d: "Structural Steel", o: 36 },
    '60605': { d: "Structural Steel", o: 41 },
    '60927': { d: "Building", o: 72 },
    '61003': { d: "Electrical Equipment", o: 36 },
    '61004': { d: "Demo", o: 63 },
    '61202': { d: "Sitework", o: 16 },
    '61701': { d: "Piping Fabrication", o: 9999 },
    '61702': { d: "Paint", o: 9999 },
    '61703': { d: "Valves & Equipment", o: 9999 },
    '61704': { d: "Valves & Equipment", o: 9999 },
    '61705': { d: "Valves & Equipment", o: 9999 },
    '61706': { d: "Valves & Equipment", o: 9999 },
    '61707': { d: "Valves & Equipment", o: 9999 },
    '61708': { d: "Valves & Equipment", o: 9999 },
    '61709': { d: "Valves & Equipment", o: 9999 },
    '61710': { d: "Valves & Equipment", o: 9999 },
    '61711': { d: "Valves & Equipment", o: 9999 },
    '61712': { d: "Valves & Equipment", o: 9999 },
    '61713': { d: "Valves & Equipment", o: 9999 },
    '61714': { d: "Valves & Equipment", o: 9999 },
    '61715': { d: "Valves & Equipment", o: 9999 },
    '61716': { d: "I&E", o: 9999 },
    '61717': { d: "I&E", o: 9999 },
    '61718': { d: "I&E", o: 9999 },
    '61719': { d: "I&E", o: 9999 },
    '61720': { d: "I&E", o: 9999 },
    '61721': { d: "I&E", o: 9999 },
    '61722': { d: "I&E", o: 9999 },
    '61723': { d: "I&E", o: 9999 },
    '61724': { d: "I&E", o: 9999 },
    '61725': { d: "Shipping", o: 9999 },
    '61726': { d: "Shipping", o: 9999 },
    '61727': { d: "Shipping", o: 9999 },
    '61901': { d: "Specialty Pipe", o: 59 },
    '61902': { d: "Specialty Pipe", o: 60 },
    '61903': { d: "Specialty Pipe", o: 61 },
    '70101': { d: "Project Support", o: 10 },
    '95250': { d: "T&M", o: 79 },
    '95350': { d: "T&M", o: 81 },
}

export const STANDARD_AREAS = [1, 2, 3, 4]

// Returns { area, discipline, order } for a standard 6-digit phase code, else null.
export function standardDisciplineFor(code) {
    const c = (code === undefined || code === null ? '' : code + '').trim()
    if (!/^[1-4][0-9]{5}$/.test(c)) return null
    const entry = WBS_STANDARD[c.slice(1)]
    if (!entry) return null
    return { area: Number(c[0]), discipline: entry.d, order: entry.o }
}
